export const lightTheme = {
  background: '#ffffff',
  backgroundOp: '#ffffff80',
  color: '#121212',
  accentColor: '#3D84C6',
  chronoTheme: {
    cardBgColor: '#e1f1ffff',
    cardForeColor: 'black',
    titleColor: 'black',
    titleColorActive: 'white',
  },
  timelineLineColor: '#ccc',
  cardBackground: '#fff',
  cardFooterBackground: '#f7f7f7',
  cardBorderColor: '#00000020',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#121212',
};

export const darkTheme = {
  background: '#121212',
  backgroundOp: '#12121280',
  color: '#eee',
  accentColor: '#5b9edeff',
  chronoTheme: {
    cardBgColor: '#1b1b2b',
    cardForeColor: '#eee',
    titleColor: 'white',
    titleColorActive: 'white',
  },
  timelineLineColor: '#444',
  cardBackground: '#060606',
  cardFooterBackground: '#181818',
  cardBorderColor: '#ffffff20',
  navbarTheme: {
    linkColor: '#dedede',
    linkHoverColor: '#fefefe',
    linkActiveColor: '#fefefe',
  },
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#fefefe',
};
